import React from 'react';
import { Flame, ArrowRight } from 'lucide-react';
export function UrgencyBanner() {
  const goToOffers = () => {
    document.getElementById('precios')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <button onClick={goToOffers} aria-label="Ver las ofertas con precio de lanzamiento" className="group block w-full bg-brand-orange hover:bg-brand-orangeHover text-white text-left active:scale-[0.99] transition-colors" data-id="element-333" data-mp="2nhn75saqhx8h">
      <div className="max-w-3xl mx-auto px-4 py-2.5 flex items-center justify-center gap-3" data-id="element-334" data-mp="2wagtuasifywd">
        <span className="shrink-0 animate-pulse" data-id="element-335" data-mp="318ia6nyjxk45">
          <Flame className="w-5 h-5 fill-white/30" data-id="element-336" data-mp="369frkybqma4l" />
        </span>
        <p className="text-[13px] sm:text-sm font-bold leading-tight text-center" data-id="element-337" data-mp="36738ghu8ttpy">
          <span className="text-yellow-200" data-id="element-338" data-mp="3b7r1ta5y2mnc">
            ✨ Enseñar con pasión no debería significar pasar horas
            planificando.
          </span>{' '}
          <span className="underline decoration-yellow-200 underline-offset-2" data-id="element-339" data-mp="1gtg9usu1zcdc"></span>
        </p>
        <span className="hidden sm:inline-flex shrink-0 items-center gap-1 bg-white/20 border border-white/30 rounded-full px-3 py-1 text-xs font-bold group-hover:bg-white/30 transition-colors" data-id="element-340" data-mp="27f82h5296n3n">
          Ver ofertas
          <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" data-id="element-341" data-mp="1xpycbuqyzei6" />
        </span>
      </div>
    </button>;
}